import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrl: './image-upload.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImageUploadComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ImageUploadComponent),
      multi: true
    }
  ]
})
export class ImageUploadComponent implements ControlValueAccessor, Validator, OnInit {
  @Input() label: string = 'Upload Image';
  @Input() maxSizeMB: number = 2; // max size in MB
  @Input() allowedTypes: string[] = ['image/jpeg', 'image/png', 'image/gif'];

  file: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;
  error: string | null = null;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  ngOnInit(): void {}

  writeValue(value: File | null): void {
    this.file = value;
    if (value) this.generatePreview(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.file) return null;

    if (this.file.size > this.maxSizeMB * 1024 * 1024) {
      return { fileTooLarge: true };
    }

    if (!this.allowedTypes.includes(this.file.type)) {
      return { invalidFileType: true };
    }

    return null;
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    this.error = null;

    if (file) {
      this.file = file;
      this.generatePreview(file);
      this.onChange(file);
      this.onTouched();
    }
  }

  generatePreview(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result;
    };
    reader.readAsDataURL(file);
  }

}

